'use client';

import { colors } from '../Utils/constants.js';

var DEFAULT_STYLE_OPTION = {
    bgColor: colors.bgHover,
    color: colors.primaryColor,
    width: '100%',
    isHaveBorder: true,
    isOverlayMarginBottom: false,
    gutter: 0,
    labelBreakpoint: {
        xs: 8,
        sm: 8,
        md: 8,
        lg: 8,
        xl: 8
    },
    progressBreakpoint: {
        xs: 16,
        sm: 16,
        md: 16,
        lg: 16,
        xl: 16
    }
};

export { DEFAULT_STYLE_OPTION };
//# sourceMappingURL=constant.js.map
